import { observer } from 'mobx-react';
import * as React from 'react';
import {
  AreaInput,
  Button,
  DateInput,
  FormCell,
  Icon,
  IconSize,
  IconType,
  Select,
  TextInput,
  FlexRow,
  Grid,
} from 'ui-toolkit';
import { mortgageSupportDocumentOptions } from '../../documentTypes';
import { ISearchReportChange } from '../../services/SearchReportService';
import { IMortgageDocumentData } from '../../../ui-toolkit/orders/interfaces/titleReport/IMortgageDocument';

// tslint:disable:jsx-no-lambda TODO: remove this tslint disable

interface IProps {
  data: IMortgageDocumentData[];
  error?: any;
  dataPath: string;
  title?: string;
  onFormChange: (dataPath: string, newData: ISearchReportChange, error?: string | null | undefined) => void;
  onAddNewItem: (dataPath: string) => void;
  onDeleteItem: (dataPath: string, index?: number) => void;
  validateFormData: (path: string) => void;
}

export const MortgageDocument = observer(
  class MortgageDocument extends React.Component<IProps, {}> {
    public static defaultProps: Partial<IProps> = {
      title: 'Documents',
    };

    public render() {
      return (
        <React.Fragment>
          <h3>{this.props.title}</h3>
          {this.props.data.map((document: IMortgageDocumentData, index: number) => {
            return (
              <React.Fragment key={`'mortgageDocument-information-${index}`}>
                <FlexRow justifyContent={'space-between'}>
                  <h4>Document No {index + 1}</h4>
                  <Button intent="ghost" isInline onClick={() => this.props.onDeleteItem(this.props.dataPath, index)}>
                    <Icon type={IconType.Remove} size={IconSize.Small} />
                  </Button>
                </FlexRow>

                <Grid columnCount={2}>
                  <FormCell
                    errorText={this.props.error[`${this.props.dataPath}[${index}].mortgageDocumentType`]}
                    label="Document type"
                  >
                    <Select
                      isClearable={true}
                      value={mortgageSupportDocumentOptions.filter(
                        (opt) => opt.value === document.mortgageDocumentType
                      )}
                      placeholder="Select"
                      options={mortgageSupportDocumentOptions}
                      onChange={(value: any, error: any) =>
                        this.onDocumentTypeChange(index, value && value.value, null)
                      }
                    />
                  </FormCell>
                  {this.props.data[index].mortgageDocumentType === 'other' ? (
                    <TextInput
                      value={document.otherMortgageDocumentType}
                      errorText={this.props.error[`${this.props.dataPath}[${index}].otherMortgageDocumentType`]}
                      label="Other document type"
                      isRequired={this.props.data[index].mortgageDocumentType === 'other'}
                      placeholder="Add document type name"
                      onChange={(value, error) => this.onChange('otherMortgageDocumentType', index, value, error)}
                      onBlur={() =>
                        this.props.validateFormData(`${this.props.dataPath}[${index}].otherMortgageDocumentType`)
                      }
                    />
                  ) : null}
                </Grid>
                <Grid columnCount={2}>
                  <TextInput
                    value={document.granteeName}
                    label="Grantee name"
                    placeholder="Ex. South Loans"
                    onChange={(value, error) => this.onChange('granteeName', index, value, error)}
                  />
                  <TextInput
                    value={document.grantorName}
                    label="Grantor name"
                    placeholder="Ex. Central Loans"
                    onChange={(value, error) => this.onChange('grantorName', index, value, error)}
                  />
                  <DateInput
                    value={document.originalDate || null}
                    errorText={this.props.error[`${this.props.dataPath}[${index}].originalDate`]}
                    label="Document date"
                    onChange={(value) => this.onChange(`originalDate`, index, value.value)}
                  />
                  <DateInput
                    value={document.recordedDate || null}
                    errorText={this.props.error[`${this.props.dataPath}[${index}].recordedDate`]}
                    label="Recorded date"
                    onChange={(value) => this.onChange(`recordedDate`, index, value.value)}
                  />
                </Grid>
                <Grid columnCount={2}>
                  <Grid columnCount={2}>
                    <TextInput
                      value={document.instrumentNumber}
                      label="Instrument No."
                      placeholder="XXXXXXXXXX"
                      onChange={(value, error) => this.onChange(`instrumentNumber`, index, value, error)}
                    />
                    <TextInput
                      value={document.book}
                      label="Book/page"
                      placeholder="XXXX"
                      onChange={(value, error) => this.onChange(`book`, index, value, error)}
                    />
                  </Grid>
                  <AreaInput
                    value={document.additionalInformation}
                    label="Additional information"
                    rows={1}
                    placeholder="Please include additional information here"
                    onChange={(value, error) => this.onChange(`additionalInformation`, index, value, error)}
                  />
                </Grid>
              </React.Fragment>
            );
          })}
        </React.Fragment>
      );
    }

    private onDocumentTypeChange = (index: number, value: string, error: string | null | undefined) => {
      this.onChange(`mortgageDocumentType`, index, value, error);
      if (value !== 'other') {
        this.onChange(`otherMortgageDocumentType`, index, null, null);
      }
    };

    private onChange = (itemDataPath: string, itemIndex: number, newValue: any, error?: string | null | undefined) => {
      this.props.onFormChange(
        this.props.dataPath,
        {
          data: newValue,
          dataPath: itemDataPath,
          index: itemIndex,
        },
        error
      );
    };
  }
);
